import toast from 'react-hot-toast'
import { useInfiniteQuery, QueryFunctionContext, useQuery } from 'react-query'
import flatten from 'lodash/flatten'
import { SortingRule } from 'react-table'

import placeService from '../services/placeService'
import { placePerPage } from '../utils/config'
import { LocationFilter } from '../types/locations'
import { Place } from '../types/utils'
import { BuzzlUsersError } from '../types/buzzl-user'

export function useLocations(params: { [x: string]: any }, filter?: LocationFilter, orderBy?: SortingRule<Place>[]) {
  return useInfiniteQuery(
    ['locations', params, filter, orderBy],
    (context: QueryFunctionContext) => {
      return placeService.getAllWithFilter(
        {
          first: placePerPage,
          skip: context.pageParam || 0,
          ...(orderBy && orderBy.length > 0
            ? { orderBy: `${orderBy[0].id}_${orderBy[0].desc ? 'DESC' : 'ASC'}` }
            : { orderBy: 'createdAt_DESC' }),
        },
        params,
        filter
      )
    },
    {
      keepPreviousData: true,
      getNextPageParam: (lastPage, allPages) => {
        if (lastPage.length < placePerPage) return false
        return flatten(allPages).length
      },
      onError: (e) => {
        const error = e as BuzzlUsersError
        error.response.errors.map((er) =>
          toast.error(er.message || 'Something went wrong, if the error persist please contact support.')
        )
      },
    }
  )
}

export function useSingleLocation(id: string | undefined) {
  return useQuery(['location', id], () => placeService.getById(id || ''), {
    enabled: !!id,
  })
}
